// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-table-row {
  width: 100%;
  height: auto;
  min-height: 13%;
  display: grid;
  flex-direction: row;
  border-bottom: 0.7px solid #DBDBDB;
  justify-content: center;
  align-items: start;
  padding: 10px 1rem;
  grid-template-columns: 5% 20% 20% 20% 20% 15%;
  place-items: center;
}
.stock-table-row > *:last-child {
  justify-self: center;
  width: 100%;
}
.stock-table-row > *:nth-child(5),
.stock-table-row > *:nth-child(6) {
  justify-self: center;
  width: 100%;
  text-align: center;
}
.stock-table-row__label {
  font-weight: bold;
  font-size: 0.85rem;
  justify-self: start;
  padding-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/stock-table-row/stock-table-row.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,mBAAA;AACJ;AAEI;EACI,oBAAA;EACA,WAAA;AAAR;AAII;;EAEI,oBAAA;EACA,WAAA;EACA,kBAAA;AAFR;AAKI;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAHR","sourcesContent":[".stock-table-row{\n    width: 100%;\n    height: auto;\n    min-height: 13%;\n    display: grid;\n    flex-direction: row;\n    border-bottom: 0.7px solid #DBDBDB;\n    justify-content: center;\n    align-items: start;\n    padding: 10px 1rem;\n    grid-template-columns: 5% 20% 20% 20% 20% 15%;\n    place-items: center;\n    \n    // Add this to ensure last column is centered\n    > *:last-child {\n        justify-self: center;\n        width: 100%;\n    }\n    \n    // Add specific styling for total and pack size columns\n    > *:nth-child(5), // TOTAL column\n    > *:nth-child(6) { // PACK SIZE column\n        justify-self: center;\n        width: 100%;\n        text-align: center;\n    }\n    \n    &__label{\n        font-weight: bold;\n        font-size: 0.85rem;\n        justify-self: start;\n        padding-left: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
